<template>
  <div class="mymodal">
      <ModalContainer>
          <!-- Stuff to be displayed that will open the modal when clicked -->
          <template #modalOpenContent>
              <div v-html="modal_click_target"> </div>
          </template>
          <!-- Stuff to be displayed inside the modal -->
          <template #modalContent>
              <div class="modal_content" v-html="modal_content"></div>
          </template>
      </ModalContainer>
  </div>
</template>

<script>
import ModalContainer from '@/components/modal/ModalContainer'

export default {
  name: "WordpressModal",
  props: ["modal_click_target", "acf_fc_layout", "modal_content"],
  components:{
      ModalContainer,
  }
};
</script>

<style lang="scss" scoped>
.modal_content{
    height:100%;
}

</style>
